(function($) {
  'use strict';

  $(document).ready(function() {
    $('html').on('click', '.form-reset', function(event) {
      event.preventDefault();
      $('.form-reset-input').click();
      return null;
    });
  });

})(jQuery);
